import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Typography,
  MenuItem,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Collapse,
  IconButton,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  FETCH_DEPARTMENT_DETAILS_LOADING,
  FETCH_USERFROM_DEPT_LOADING,
  UPDATE_DEPARTMENT_DETAILS,
} from "../../../../../../containers/actions/types";
import { fetchDepartmentDetails } from "../../../../../../containers/actions/userActions";
import { fetchUserfromDepartment } from "../../../../../../containers/actions/userActions";
import {
  ChevronLeft,
  ChevronRight,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";

import CloseIcon from "@material-ui/icons/Close";
// import { fetchAlpatiaDefaultSettings } from '../../../../../containers/actions/ecosystemActions';
// import usePrevious from '../../../../pcmp/components/helpers/previousProps';
import { useDispatch, useSelector } from "react-redux";
// import { Autocomplete } from '@material-ui/lab';
// import { updateOrgProfile } from '../../../../../containers/actions/userActions';
// import BackDrop from '../../../../../components/pcmp/components/common/models/BackDrop';
import BackDrop from "../../models/BackDrop";
import EditDepartmentScreen from "./EditDepartmentScreen";
import usePrevious from "../../../helpers/previousProps";
// import CheckCircleIcon from '@material-ui/icons/CheckCircle';
// import { UPDATE_ORG_FAIL } from '../../../../../containers/actions/types';
// import { Country, State, City } from 'country-state-city';
// import postalCodes from 'postal-codes-js';

const useStyles = makeStyles((theme) => ({
  header: {
    // backgroundColor: "#F5F9FF",
    backgroundColor: "#f9f9fc",
    // paddingTop: "0.5rem",
    // paddingBottom: "0.5rem",
  },
  table: {
    border: "1px solid #D3D3D3",
    minWidth: 200,
    margin: "auto",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1rem",
    backgroundColor: "#F5F9FF",
  },
  head: {
    textAlign: "center",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "12px",
    right: "10px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#FF0000",
    },
  },

  content: {
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  inline: {
    fontSize: "1.2rem",
    display: "inline",
    fontWeight: 500,
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  heading: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  hr: {
    border: "0.5px solid #000000de",
    marginTop: "3rem",
    marginBottom: "2rem",
    width: "100%",
    borderBottom: "thick",
  },
  textfieldWidth: {
    width: "85%",
    marginTop: "8px",
  },
  hideDropdown: {
    "& .MuiAutocomplete-popupIndicator": {
      display: "none",
    },
    "& .MuiAutocomplete-clearIndicator": {
      display: "none",
    },
  },
  hideDeleteIcon: {
    "& .MuiChip-deleteIcon": {
      display: "none",
    },

    color: "#000000",
    border: "1px solid #000000",
    marginRight: "4px",
  },

  required: {
    color: "red",
    marginLeft: "4px",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontWeight: 600,
  },
  input: {
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&[type=number]": {
      "-moz-appearance": "textfield",
    },
    // Additional styles to disable scrolling
    overflow: "hidden",
    pointerEvents: "none", // Prevents pointer events on the input
    touchAction: "none", // Disables touch actions
    userSelect: "none", // Disables text selection
    resize: "none", // Prevents resizing
  },
  dialogContent: {
    textAlign: "center",
    padding: "24px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "54px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
}));

const ViewDepartmentScreen = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { openDialog, closeViewDepartments, fetchedData } = props;
  const [departmentDetailsData, setDepartmentDetailsData] = useState([]);
  const [loading, setLoading] = useState(true);
  // const fetchDepartmentsData = useSelector((state) =>
  //   state?.user?.fetchDepartments ? state?.user?.fetchDepartments : []
  // );

  const fetchDepartmentsData = useSelector((state) =>
    state?.user?.fetchUserfromDeptDetails
      ? state?.user?.fetchUserfromDeptDetails
      : null
  );
  // const fetchDepartmentsData = useSelector((state) =>
  //   state?.user?.fetchUserfromDeptDetails
  //     ? state?.user?.fetchUserfromDeptDetails
  //     : "data"
  // ); 

  useEffect(() => {
    dispatch({
      type: FETCH_USERFROM_DEPT_LOADING,
      payload: true,
    });
    dispatch(fetchUserfromDepartment());
  }, []);

  let errors = useSelector((state) =>
    state?.user?.fetchDepartments
      ? state.user.fetchDepartments
      : {
          status: "false",
          errorDescription:
            "Something went wrong. Please contact Schrocken Support.",
        }
  );

  useEffect(() => {
    dispatch({
      type: FETCH_DEPARTMENT_DETAILS_LOADING,
      payload: true,
    });
    dispatch(fetchDepartmentDetails());
  }, []);

  let fetchLogisticsLoading = useSelector(
    (state) => state.user.fetchDepartmentsLoading
  );

  const handleCancel = () => {
    dispatch({
      type: UPDATE_DEPARTMENT_DETAILS,
      payload: {},
    });
    closeViewDepartments();
  };
  const formatValue = (value) =>
    value === undefined || value === null || value === "" ? "NA" : value;

  useEffect(() => {
    if (fetchDepartmentsData && fetchDepartmentsData.status) {
      const formattedData = fetchDepartmentsData.departmentDetailsList.map(
        (department) => ({
          departmentID: formatValue(department.departmentID),
          departmentName: formatValue(department.departmentName),
          departmentType: formatValue(department.departmentType),
          roles: department.rolesList || [], // Default to empty array if roles are missing
        })
      );
      setDepartmentDetailsData(formattedData);
    }
  }, [fetchDepartmentsData]);

  //console.log("setDepartmentDetailsData", departmentDetailsData);

  return (
    <>
      <BackDrop />
      <Dialog open={openDialog} fullScreen>
        <DialogTitle style={{ padding: "0px" }}>
          <Grid item xs={12} className={classes.header}>
            <Grid item xs={12} className={classes.titleGrid}>
              <Grid item xs={12} className={classes.head}>
                <Typography variant="h6" style={{ fontSize: "1.875rem" }}>
                  View departments
                </Typography >
                <Typography  style={{ fontSize: "1.2rem", color: "#444" }}>
                  Review details of the departments
                  </Typography>
              </Grid>
            </Grid>

            
            <Grid item xs={2} sm={2} md={2}>
              <Typography
                variant="body2"
                className={classes.closeBtn}
                onClick={handleCancel}
              >
                Cancel{" "}
                <CloseIcon style={{ fontSize: "35px", color: "#FF0000" }} />
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        

        <DialogContent
          style={{
            maxWidth: "70vw", // Limits the width to 70% of the viewport
            width: "100%", // Ensures the content uses the available width
            margin: "0 auto", // Centers the content horizontally
            paddingTop: "32px", // Maintains top padding for spacing
            display: "flex", // Enables flexbox for centering
            justifyContent: "center", //
          }}
        >
          {/* <Typography variant="h6" gutterBottom>
        Department details
      </Typography> */}

          {/* <Grid xs={12} sm={6}>
            <Typography variant="body2" className={classes.heading}>
              Department details
            </Typography>
            <hr className={classes.hrLine} />
          </Grid>
          <Grid style={{ marginBottom: "1.2rem" }}>
            <Typography variant="body1" className={classes.inline}>
              List of departments{" "}
            </Typography>
          </Grid> */}
          {/* <Typography variant="subtitle1" gutterBottom>
        List of departments
      </Typography> */}

         
      
          <TableContainer
            style={{
              maxHeight: "100%",
              overflowY: "auto",
              marginBottom: "2em",
            }}
          >
            <Grid item xs={12}>
                                    <Typography variant="body2" className={classes.inline} style={{ fontSize: "1.87rem",fontStyle: "500"}}>
                                     Department details
                                    </Typography>
                                    <hr className={classes.hrLine} />
                                  </Grid>
                                  <Grid
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                marginTop: "2rem",
                                                marginBottom: "2rem"
                                                // width: "50.2rem",
                                                // width: "70vw",
                                  
                                                // backgroundColor: "red",
                                              }}
                                              xs={12}
                                            >
                                             
                                              <Grid>
                                                <Typography variant="body1" className={classes.inline}>
                                                  List of departments
                                                 
                                                </Typography>
                                              </Grid>
                                              
                                            </Grid>

            <Table className={classes.table}>
              <TableHead
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  // backgroundColor: "#F5F9FF",
                  backgroundColor: "red",
                }}
              >
                <TableRow>
                  <TableCell className={classes.header}>
                    Department name
                  </TableCell>
                  <TableCell className={classes.header}>
                    Department ID
                  </TableCell>
                  <TableCell className={classes.header}>
                    Department Type
                  </TableCell>
                  <TableCell className={classes.header}>
                    Role (No. of team members)
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fetchDepartmentDetails.status === true ? (
                  <TableRow style={{ height: 150 }}>
                    <TableCell colSpan={12}>
                      <div style={{ textAlign: "center" }}>
                        {/* <CircularProgress color="primary" thickness={7} /> */}
                      </div>
                    </TableCell>
                  </TableRow>
                ) : departmentDetailsData?.length > 0 ? (
                  departmentDetailsData.map((department, index) => (
                    <TableRow
                      key={index}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#FFFFFF" : "#f9f9fc", // Alternate colors
                      }}
                    >
                      <TableCell>{department.departmentName}</TableCell>
                      <TableCell>{department.departmentID}</TableCell>
                      <TableCell>{department.departmentType}</TableCell>
                      <TableCell>
                        {department.roles?.length > 0
                          ? department.roles.map((role, roleIndex) => (
                              <Typography key={roleIndex}>
                                {role.role_name} ({role.userCount})
                              </Typography>
                            ))
                          : "NA"}
                      </TableCell>
                    </TableRow>
                  ))
                ) : fetchDepartmentDetails?.status === false ? (
                  <TableRow
                    style={{
                      border: "2px solid rgb(255,0,0)",
                      backgroundColor: "rgb(255,240,240)",
                      Opacity: 1,
                      textAlign: "center",
                      padding: "0.8rem",
                      fontSize: "0.875rem",
                    }}
                  >
                    <TableCell colSpan={10} align="center">
                      'Something went wrong. Please contact Schrocken support.'
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      No records found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ViewDepartmentScreen;
